import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotGossip() {
  const hotArticles = articles.filter((a) => a.isHot);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs text-foreground-500 font-label uppercase tracking-wider">Hot Gossip</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              今日热门吃瓜
            </h2>
          </div>
          <Link
            to="/category/wanghong-tafang"
            className="text-sm text-primary-500 hover:text-primary-600 font-label flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="overflow-x-auto pb-4">
          <div className="flex gap-5 min-w-max">
            {hotArticles.map((article) => (
              <article
                key={article.slug}
                className="w-[280px] shrink-0 bg-background-50 rounded-lg overflow-hidden hover:bg-background-100 transition-colors group cursor-pointer"
              >
                <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                  <div className="relative w-full h-[180px] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="text-xs bg-primary-500 text-background-50 px-2.5 py-0.5 rounded-full font-label">
                        热门
                      </span>
                    </div>
                  </div>
                </Link>
                <div className="p-4">
                  <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                    <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                      {article.title}
                    </h3>
                  </Link>
                  <div className="flex items-center justify-between mt-3 text-xs text-foreground-500 font-label">
                    <span>{article.publishDate}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {(article.readCount / 10000).toFixed(0)}万
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}